let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("edK2X")).then(() => parcelRequire('5ujOp'));